import {useCallback, useMemo} from 'react';
import cx from 'classnames';
import {EditorIcon} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcon';

import './EditorIcons.sass';

const getIconId = (icon) => (typeof icon === 'object' ? icon?.id : icon || 'none');
export const EditorIcons = ({
  icons = [],
  onClick,
  selectedIcon,
  height,
  width,
  className,
  hideAnimatedIndicator,
  flipEnvelope,
  showEnvelopeFront,
  circle,
  noPadding = false,
  outline = false,
}) => {
  const onClickHandler = useCallback(onClick, [onClick]);

  const iconsMemo = useMemo(
    () =>
      icons?.map((icon) => {
        if (icon?.component) return icon.component;
        const iconId = getIconId(icon);
        return (
          <EditorIcon
            key={iconId}
            icon={icon}
            onClick={onClickHandler}
            isActive={getIconId(selectedIcon) === iconId}
            height={height}
            width={width}
            hideAnimatedIndicator={hideAnimatedIndicator}
            flipEnvelope={flipEnvelope}
            showEnvelopeFront={showEnvelopeFront}
            circle={circle}
            outline={outline}
          />
        );
      }),
    [
      icons,
      onClickHandler,
      getIconId,
      selectedIcon,
      height,
      width,
      hideAnimatedIndicator,
      flipEnvelope,
      showEnvelopeFront,
      circle,
      outline,
    ]
  );

  return (
    <div className={cx('editor-icons', className, {'editor-icons--no-padding': noPadding})}>
      {iconsMemo}
    </div>
  );
};
